module.exports = __webpack_public_path__ + "img/UA house 二维码.73af6eb.png";